import { InputHTMLAttributes, useEffect, useRef, useState, useCallback } from 'react'
import { IconBaseProps } from 'react-icons/lib'
import { FiAlertCircle } from 'react-icons/fi'
import { useField } from '@unform/core'

import { Container, Error } from './styles'
import { LabelInput } from '../Input/styles'

interface IOptions {
  label: string
  value: string | number
}

interface SelectProps extends InputHTMLAttributes<HTMLSelectElement> {
  name: string
  options: IOptions[]
  icon?: React.ComponentType<IconBaseProps>
  color?: string
  background?: string
  placeholdColor?: string
  label?: string
}

const Input: React.FC<SelectProps> = ({
  icon: Icon,
  name,
  options,
  color,
  background,
  label,
  placeholdColor,
  ...rest
}) => {
  const inputRef = useRef<HTMLSelectElement>(null)
  const [isFocused, setIsFocused] = useState(false)
  const [isFilled, setIsFilled] = useState(false)
  const { fieldName, defaultValue, registerField, error } = useField(name)

  const handleInputBlur = useCallback(() => {
    setIsFocused(false)

    setIsFilled(!!inputRef.current?.value)
  }, [])

  const handleInputFocus = useCallback(() => {
    setIsFocused(true)
  }, [])

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      // getValue: (ref) => ref.current?.value,
      // setValue: (ref, value) => {
      //   ref.current.value = value
      // },
      // clearValue: (ref) => {
      //   ref.current.value = ''
      // },
    })
  }, [fieldName, registerField])

  return (
    <>
      {label ? <LabelInput>{label}</LabelInput> : ''}
      <Container
        isFilled={isFilled}
        isFocused={isFocused}
        isErrored={!!error}
        color={color}
        background={background}
        placeholdColor={placeholdColor}
      >
        {Icon && <Icon size={20} />}
        <select
          defaultValue={defaultValue}
          ref={inputRef}
          {...rest}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
        >
          <option selected disabled value="">
            {rest.placeholder}
          </option>
          {options &&
            options.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
        {error && (
          <Error title={error}>
            <FiAlertCircle color="#C53030" size={20} />
          </Error>
        )}
      </Container>
    </>
  )
}

export default Input
